import React, { useState, useEffect, useRef } from 'react';
import PodlesokSection from './Form3/PodlesokSection';
import PodrostSection from './Form3/PodrostSection';
import PickerModal from './Form3/PickerModal';
import { getEmptyFormData } from './Form3/constants';
import { usePicker } from './Form3/pickerHooks';

const Form3 = ({ handbooks, formData, setFormData, selectedDoc }) => {

  // Используем formData из props напрямую
  const displayData = formData || getEmptyFormData();
  const setLocalFormData = setFormData;

  // Состояние для валидации
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  // Состояние для слайдера таблицы
  const [podlesokScrollPosition, setPodlesokScrollPosition] = useState(0);
  const podlesokTableScrollRef = useRef(null);

  // Функции для работы со слайдером таблицы подлеска
  const handlePodlesokSliderChange = (e) => {
    const newPosition = parseInt(e.target.value);
    setPodlesokScrollPosition(newPosition);
    if (podlesokTableScrollRef.current) {
      const maxScroll = podlesokTableScrollRef.current.scrollWidth - podlesokTableScrollRef.current.clientWidth;
      const scrollLeft = (newPosition / 100) * maxScroll;
      podlesokTableScrollRef.current.scrollLeft = scrollLeft;
    }
  };

  const handlePodlesokTableScroll = () => {
    if (podlesokTableScrollRef.current) {
      const maxScroll = podlesokTableScrollRef.current.scrollWidth - podlesokTableScrollRef.current.clientWidth;
      const currentScroll = podlesokTableScrollRef.current.scrollLeft;
      const percentage = (currentScroll / maxScroll) * 100;
      setPodlesokScrollPosition(percentage);
    }
  };


  // Используем хук для работы с picker
  const {
    showPicker,
    pickerField,
    pickerOptions,
    pickerValue,
    pickerSearch,
    selectedOptionIndex,
    openPicker,
    closePicker,
    selectPickerValue,
    getFilteredOptions,
    getSelectedIndexInFiltered,
    setPickerSearch
  } = usePicker(
    handbooks,
    displayData,
    setLocalFormData,
    setFormData
  );

  // Валидация обязательных полей Form3 - все поля необязательные
  useEffect(() => {
    if (formData) {
      // Все поля необязательные, поэтому ошибок валидации нет
      const hasErrors = false;
      
      if (hasValidationErrors !== hasErrors) {
        setHasValidationErrors(hasErrors);
        
        const newData = {
          ...displayData,
          form3ValidationErrors: hasErrors
        };
        setLocalFormData(newData);
        if (setFormData) {
          setFormData(newData);
        }
      }
    }
  }, [formData, hasValidationErrors, setFormData, displayData, setLocalFormData]);

  // Функции для работы с подлеском
  const updatePodlesokItem = (id, field, value) => {
    const newPodlesok = displayData.podlesok.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    );
    
    const newData = { ...displayData, podlesok: newPodlesok };
    setLocalFormData(newData);
    if (setFormData) {
      setFormData(newData);
    }
  };

  // Функции для работы с подростом
  const updatePodrostItem = (id, field, value) => {
    const newPodrost = displayData.podrost.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    );
    
    const newData = { ...displayData, podrost: newPodrost };
    setLocalFormData(newData);
    if (setFormData) {
      setFormData(newData);
    }
  };


  return (
    <>
      <div className="template-section">
        <div 
          className="template-header" 
          style={{ cursor: 'pointer', padding: '10px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <h3>III. Форма ввода дополнительных сведений лесоустройства</h3>
        </div>
        
        <div className="template-content">
          {/* Подлесок */}
          <PodlesokSection
            displayData={displayData}
            handbooks={handbooks}
            updatePodlesokItem={updatePodlesokItem}
            openPicker={openPicker}
            podlesokTableScrollRef={podlesokTableScrollRef}
            podlesokScrollPosition={podlesokScrollPosition}
            handlePodlesokSliderChange={handlePodlesokSliderChange}
            handlePodlesokTableScroll={handlePodlesokTableScroll}
          />

          {/* Подрост */}
          <PodrostSection
            displayData={displayData}
            handbooks={handbooks}
            updatePodrostItem={updatePodrostItem}
            openPicker={openPicker}
          />
        </div>

        {/* Picker для справочников */}
        <PickerModal
          showPicker={showPicker}
          pickerSearch={pickerSearch}
          setPickerSearch={setPickerSearch}
          getFilteredOptions={getFilteredOptions}
          getSelectedIndexInFiltered={getSelectedIndexInFiltered}
          pickerValue={pickerValue}
          selectPickerValue={selectPickerValue}
          closePicker={closePicker}
        />
      </div>
    </>
  );
};

export default Form3;
